"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthScopes = exports.hasScope = exports.hasAllScopes = exports.hasAnyScope = void 0;
/**
 * Check to see if the current user roles contains any of the chosen scopes.
 * @param roles Array of scopes belonging to the current user
 * @param scopes Scopes you want to check
 * @returns boolean
 */
function hasAnyScope(roles, scopes) {
    var uniqueScopes = new Set(roles);
    // Array.some returns false if the input array is empty
    return scopes.some(function (role) { return uniqueScopes.has(role); });
}
exports.hasAnyScope = hasAnyScope;
/**
 * Check to see if the current user roles contains ALL of the chosen scopes.
 * @param roles Array of scopes belonging to the current user
 * @param scopes Scopes you want to check
 * @returns boolean
 */
function hasAllScopes(roles, scopes) {
    var uniqueScopes = new Set(roles);
    // This check is necessary as Array.every returns true if the input array is empty
    return scopes.length === 0 ? false : scopes.every(function (scope) { return uniqueScopes.has(scope); });
}
exports.hasAllScopes = hasAllScopes;
/**
 * Check to see if the current user roles contains the chosen scope
 * @param roles Array of scopes belonging to the current user
 * @param scope Single scope to check
 * @returns boolean
 */
function hasScope(roles, scope) {
    return hasAnyScope(roles, [scope]);
}
exports.hasScope = hasScope;
/**
 * Helper class for determining the roles of a token.
 */
var AuthScopes = /** @class */ (function () {
    function AuthScopes(tokenParsed) {
        var _a, _b;
        this.scopes = (_b = (_a = tokenParsed === null || tokenParsed === void 0 ? void 0 : tokenParsed.scope) === null || _a === void 0 ? void 0 : _a.split(' ')) !== null && _b !== void 0 ? _b : [];
    }
    AuthScopes.prototype.hasScope = function (scope) {
        return hasScope(this.scopes, scope);
    };
    AuthScopes.prototype.hasAllScopes = function (scopes) {
        return hasAllScopes(this.scopes, scopes);
    };
    AuthScopes.prototype.hasAnyScope = function (scopes) {
        return hasAnyScope(this.scopes, scopes);
    };
    return AuthScopes;
}());
exports.AuthScopes = AuthScopes;
